import { Button, Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import React from "react";
import { useMaterialUIController } from "context";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PropTypes from "prop-types";
import useCopyToClipboard from "../../../../custom-hooks/useCopyToClipboard";

const ApiDescription = ({ data, search }) => {
  // Fetch Color Modes
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [, copy] = useCopyToClipboard();

  const filter = () => {
    return data?.filter((childVal) => {
      if (search?.toLowerCase() === "") {
        return childVal;
      } else {
        return (
          childVal?.parentHeading
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeading
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingStatic
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingDescStatic
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.subheadingIntro
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.subheadingDesc
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.subheadingDescTwo
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.subheadingDescThree
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.generalDescWithLinkOne?.link
            ?.toLowerCase()
            ?.includes(search.toLowerCase())
        );
      }
    });
  };
  const filtered = filter();

  return (
    <>
      {filtered.length === 0 ? (
        <MDTypography
          variant="h3"
          fontWeight="regular"
          fontFamily="inherit"
          textAlign="center"
          lineHeight={2}
          id="no-data-found"
        >
          No Results Found!
        </MDTypography>
      ) : (
        filtered.map((childVal) => {
          return (
            <React.Fragment
              key={childVal.mainGridIdStatic || childVal.subheadingIntroId}
            >
              {childVal.mainGridIdStatic && (
                <Grid container xs={12} mt={4} id={childVal.mainGridIdStatic}>
                  {childVal.mainHeadingStatic && (
                    <MDTypography
                      variant="h4"
                      fontWeight="bold"
                      fontFamily="inherit"
                      lineHeight={1.5}
                      className="section"
                      width="100%"
                      display="block"
                    >
                      {childVal.mainHeadingStatic}
                    </MDTypography>
                  )}
                  {childVal.mainHeadingDescStatic && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.mainHeadingDescStatic}
                    </MDTypography>
                  )}
                  {childVal.mainHeadingDescOne && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      style={{ display: "block", width: "100%" }}
                    >
                      {childVal.mainHeadingDescOne}
                    </MDTypography>
                  )}
                  {childVal.list && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      style={{ display: "block" }}
                      mt={2}
                    >
                      <ul>
                        {childVal.list.map((val) => (
                          <li key={val.a}>{val.a}</li>
                        ))}
                      </ul>
                    </MDTypography>
                  )}
                  {childVal.mainHeadingDescthree && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.mainHeadingDescthree}
                      <br />
                      <br />
                    </MDTypography>
                  )}
                  {childVal.listTwo && (
                    <Grid container xs={12} mt={4}>
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal?.listTwo ? childVal?.examp : ""}
                        <br />
                        <ul>
                          <li>{childVal.exampleOne}</li>
                          <ul>
                            {childVal.listTwo.map((val, ind) => (
                              <li key={val.b}>{val.b}</li>
                            ))}
                          </ul>
                        </ul>
                      </MDTypography>
                    </Grid>
                  )}
                  {childVal.listThree && (
                    <Grid container xs={12} mt={4}>
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        <ul>
                          <li>{childVal.exampleTwo}</li>
                          <ul>
                            {childVal.listThree.map((val) => (
                              <li key={val.c}>{val.c}</li>
                            ))}
                          </ul>
                        </ul>
                      </MDTypography>
                    </Grid>
                  )}
                  {childVal.listFour && (
                    <Grid container xs={12} mt={4}>
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal.exampleThree}
                        <br />
                        <ul>
                          {childVal.listFour.map((val) => (
                            <li key={val.d}>{val.d}</li>
                          ))}
                        </ul>
                      </MDTypography>
                    </Grid>
                  )}
                  {childVal.generalDescWithLinkOne && (
                    <p className="doc-text" style={{ marginLeft: "10px" }}>
                      {childVal.generalDescWithLinkOne.link}
                      <Button
                        variant="text"
                        className="copyiconparent"
                        onClick={() =>
                          copy(childVal.generalDescWithLinkOne.link)
                        }
                      >
                        <ContentCopyIcon className="copyicon" />
                      </Button>
                    </p>
                  )}
                  {childVal.mainHeadingDescStaticTwo && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.mainHeadingDescStaticTwo}
                    </MDTypography>
                  )}
                  {childVal.diagramOneLabel && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      textAlign="center"
                      lineHeight={2}
                      display="block"
                      marginBottom="25px"
                      width="100%"
                    >
                      <i className="text-center d-block">
                        {childVal.diagramOneLabel}
                      </i>
                    </MDTypography>
                  )}
                  {childVal.diagramTwoLabel && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      textAlign="center"
                      lineHeight={2}
                      display="block"
                      marginBottom="25px"
                      width="100%"
                    >
                      <i className="text-center d-block">
                        {childVal.diagramTwoLabel}
                      </i>
                    </MDTypography>
                  )}
                </Grid>
              )}
              {childVal.subheadingIntro && (
                <Grid container xs={12} mt={4} id={childVal.subheadingIntroId}>
                  {childVal.subheadingIntro && (
                    <MDTypography
                      variant="h5"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={1.5}
                      className="section"
                      width="100%"
                      display="block"
                    >
                      {childVal.subheadingIntro}
                    </MDTypography>
                  )}
                  {childVal.subheadingDesc && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.subheadingDesc}
                    </MDTypography>
                  )}
                  {childVal.subheadingDescTwo && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      <br />
                      {childVal.subheadingDescTwo}
                    </MDTypography>
                  )}
                  {childVal.subheadingDescThree && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      <br />
                      {childVal.subheadingDescThree}
                    </MDTypography>
                  )}
                  {childVal.sessionTable && (
                    <MDBox mt={3} className="table-doc w-100">
                      <Card>
                        <MDBox className={darkMode ? "dark-tbl" : "light-tbl"}>
                          <DataTable
                            table={{
                              columns: childVal.sessionTable.columns,
                              rows: childVal.sessionTable.rows,
                            }}
                            isSorted={false}
                            entriesPerPage={{
                              defaultValue: 1000,
                            }}
                            showTotalEntries
                            pagination={{ variant: "gradient", color: "info" }}
                            noEndBorder
                          />
                        </MDBox>
                      </Card>
                    </MDBox>
                  )}
                  {childVal.subheadingTableDescBottom && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      paddingTop="30px"
                    >
                      {childVal.subheadingTableDescBottom}
                    </MDTypography>
                  )}
                </Grid>
              )}
            </React.Fragment>
          );
        })
      )}
    </>
  );
};

ApiDescription.propTypes = {
  data: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
};
export default ApiDescription;
